import React, { Component } from 'react'
import ReactEcharts from 'echarts-for-react';


export default function(options) {
  return <ReactEcharts {...options} />
}
